import PageEvent from './PageEvent.js';
import Util from './Util.js';


export default class Top extends PageEvent {

	constructor() {

		super();

		this.DOM = {};

	}

	/*
	** scrollToTop
	*/

	scrollToTop () {

		Util.scrollToElement('body,html', 1.2);

	}

	/*
	** resize
	*/

	resize (event) {

		this.update();

	}

	/*
	** scroll
	*/

	scroll (event) {

		this.update();

	}

	/*
	** update
	*/

	update() {

		if ( Util.getScrollTop() > 0 )
		{
			this.DOM.container.classList.remove('hidden');
		}
		 else
		{
			this.DOM.container.classList.add('hidden');
		}

	}

	/*
	** load
	*/

	load() {

		// super
		super.load();

		// container
		this.DOM.container = document.querySelector('.footer .top');

		// button
		this.DOM.button = this.DOM.container.querySelector('.top__anchor');

		this.DOM.button.addEventListener('click', event =>
		{
			event.preventDefault();

			event.stopPropagation();

			this.scrollToTop();

			return false;

		}, false);

		// update
		this.update();

	}

}
